import { createReducer } from '../../../utils/reducerUtil';
import { ACTION_STATUS } from '../../../utils/ActionStatus';

import {
  ON_CPT_QUERY_INPUT_CHANGE,
  START_LOAD_CPT_EMPLOYEE_OPTIONS,
  LOAD_CPT_EMPLOYEE_OPTIONS_SUCCESS,
  LOAD_CPT_EMPLOYEE_OPTIONS_FAILURE,
  INIT_LOAD_CPT_EMPLOYEE_OPTIONS_ACTION_STATUS,
  START_LOAD_CPT_INFO,
  LOAD_CPT_INFO_SUCCESS,
  LOAD_CPT_INFO_FAILURE,
  INIT_LOAD_CPT_INFO_ACTION_STATUS,
  SELECT_CPT_INFO,
  OPEN_ADD_OR_EDIT_CPT_MODAL,
  ADD_OR_EDIT_CPT_CHANGE_INPUT,
  START_ADD_OR_EDIT_CPT,
  ADD_OR_EDIT_CPT_SUCCESS,
  ADD_OR_EDIT_CPT_FAILURE,
  INIT_ADD_OR_EDIT_CPT_ACTION_STATUS,
  RESET_ADD_OR_EDIT_CPT_MODAL,
  START_SUBMIT_CPT_APPROVAL,
  SUBMIT_CPT_APPROVAL_SUCCESS,
  SUBMIT_CPT_APPROVAL_FAILURE,
  INIT_SUBMIT_CPT_APPROVAL_ACTION_STATUS,
  OPEN_DEL_CPT_MODAL,
  START_DEL_CPT,
  DEL_CPT_SUCCESS,
  DEL_CPT_FAILURE,
  INIT_DEL_CPT_ACTION_STATUS,
  RESET_DEL_CPT_MODAL,
  CPT_NOTE_CHANGE_INPUT,
  START_LOAD_CPT_NOTE,
  LOAD_CPT_NOTE_SUCCESS,
  LOAD_CPT_NOTE_FAILURE,
  INIT_LOAD_CPT_NOTE_ACTION_STATUS,
  START_ADD_OR_EDIT_CPT_NOTE,
  ADD_OR_EDIT_CPT_NOTE_SUCCESS,
  ADD_OR_EDIT_CPT_NOTE_FAILURE,
  INIT_ADD_OR_EDIT_CPT_NOTE_ACTION_STATUS,
  RESET_CPT_NOTE_MODAL,
} from './CptConstants';

const initialCptFields = {
  id: null,
  employee: '',
  eventDate: '',
  eventOrganizer: '',
  eventName: '',
  cptCategory: '',
  cptHours: '',
  attachment: '',
  attachmentOriginName: '',
  complianceApproval: '',
  fileList: [],
};

const initialState = {
  employeeOptions: [],
  cptQueryFields: {
    employee: '',
    year: '',
  },
  loadCptEmployeeOptionsActionStatus: ACTION_STATUS.READY,
  loadCptInfoActionStatus: ACTION_STATUS.READY,
  loadCptInfoResp: null,
  selectedCptInfoArray: [],
  addOrEditCptModal: {
    isOpened: false,
    mode: 'ADD',
    respErrMsg: '',
    fields: initialCptFields,
  },
  addOrEditCptActionStatus: ACTION_STATUS.READY,
  submitCptApprovalRespErrMsg: '',
  submitCptApprovalActionStatus: ACTION_STATUS.READY,
  delCptModal: {
    isOpened: false,
    respErrMsg: '',
    fields: {
      id: null,
    },
  },
  delCptActionStatus: ACTION_STATUS.READY,
  cptNoteModal: {
    isOpened: false,
    respErrMsg: '',
    fields: {
      id: null,
      note: '',
    },
  },
  loadCptNoteActionStatus: ACTION_STATUS.READY,
  loadCptNoteRespErrMsg: '',
  addOrEditCptNoteActionStatus: ACTION_STATUS.READY,
};

function onCptQueryInputChange(state, { name, value }) {
  return {
    ...state,
    cptQueryFields: {
      ...state.cptQueryFields,
      [name]: value,
    },
  };
}

function startLoadCptEmployeeOptions(state) {
  return {
    ...state,
    loadCptEmployeeOptionsActionStatus: ACTION_STATUS.LOGINING,
  };
}

function loadCptEmployeeOptionsSuccess(state, resp) {
  return {
    ...state,
    loadCptEmployeeOptionsActionStatus: ACTION_STATUS.SUCCESS,
    employeeOptions: resp && resp.data ? resp.data : [],
  };
}

function loadCptEmployeeOptionsFailure(state) {
  return {
    ...state,
    loadCptEmployeeOptionsActionStatus: ACTION_STATUS.ERROR,
  };
}

function initLoadCptEmployeeOptionsActionStatus(state) {
  return {
    ...state,
    loadCptEmployeeOptionsActionStatus: ACTION_STATUS.READY,
  };
}

function startLoadCptInfo(state) {
  return {
    ...state,
    loadCptInfoActionStatus: ACTION_STATUS.LOGINING,
  };
}

function loadCptInfoSuccess(state, resp) {
  return {
    ...state,
    loadCptInfoActionStatus: ACTION_STATUS.SUCCESS,
    loadCptInfoResp: resp,
  };
}

function loadCptInfoFailure(state, err) {
  return {
    ...state,
    loadCptInfoActionStatus: ACTION_STATUS.ERROR,
    loadCptInfoResp: err,
  };
}

function initLoadCptInfoActionStatus(state) {
  return {
    ...state,
    loadCptInfoActionStatus: ACTION_STATUS.READY,
    selectedCptInfoArray: [],
  };
}

function selectCptInfo(state, array) {
  return {
    ...state,
    selectedCptInfoArray: array,
  };
}

function openAddOrEditCptModal(state, { mode, data }) {
  if (mode === 'ADD' || !data) {
    return {
      ...state,
      addOrEditCptModal: {
        ...state.addOrEditCptModal,
        isOpened: true,
        mode,
        respErrMsg: '',
        fields: initialCptFields,
      },
    };
  }

  const isCopy = mode === 'COPY';
  return {
    ...state,
    addOrEditCptModal: {
      ...state.addOrEditCptModal,
      isOpened: true,
      mode,
      respErrMsg: '',
      fields: {
        id: isCopy ? null : data.id,
        employee: data.employee || '',
        eventDate: data.eventDate || '',
        eventOrganizer: data.eventOrganizer || '',
        eventName: data.eventName || '',
        cptCategory: data.cptCategory || '',
        cptHours: data.cptHours || '',
        attachment: data.attachment || '',
        attachmentOriginName: data.attachmentOriginName || '',
        complianceApproval: isCopy ? '' : (data.complianceApproval || ''),
        fileList: data.attachment ? [{
          uid: '-1',
          name: data.attachmentOriginName || data.attachment,
          status: 'done',
          url: data.attachment,
        }] : [],
      },
    },
  };
}

function addOrEditCptChangeInput(state, { name, value }) {
  return {
    ...state,
    addOrEditCptModal: {
      ...state.addOrEditCptModal,
      fields: {
        ...state.addOrEditCptModal.fields,
        [name]: value,
      },
    },
  };
}

function startAddOrEditCpt(state) {
  return {
    ...state,
    addOrEditCptActionStatus: ACTION_STATUS.LOGINING,
  };
}

function addOrEditCptSuccess(state) {
  return {
    ...state,
    addOrEditCptActionStatus: ACTION_STATUS.SUCCESS,
  };
}

function addOrEditCptFailure(state, err) {
  return {
    ...state,
    addOrEditCptActionStatus: ACTION_STATUS.ERROR,
    addOrEditCptModal: {
      ...state.addOrEditCptModal,
      respErrMsg: err && err.respMessage ? err.respMessage : '',
    },
  };
}

function initAddOrEditCptActionStatus(state) {
  return {
    ...state,
    addOrEditCptActionStatus: ACTION_STATUS.READY,
  };
}

function resetAddOrEditCptModal(state) {
  return {
    ...state,
    addOrEditCptModal: {
      ...initialState.addOrEditCptModal,
      fields: initialCptFields,
    },
  };
}

function startSubmitCptApproval(state) {
  return {
    ...state,
    submitCptApprovalActionStatus: ACTION_STATUS.LOGINING,
    submitCptApprovalRespErrMsg: '',
  };
}

function submitCptApprovalSuccess(state) {
  return {
    ...state,
    submitCptApprovalActionStatus: ACTION_STATUS.SUCCESS,
  };
}

function submitCptApprovalFailure(state, err) {
  return {
    ...state,
    submitCptApprovalActionStatus: ACTION_STATUS.ERROR,
    submitCptApprovalRespErrMsg: err && err.respMessage ? err.respMessage : '',
  };
}

function initSubmitCptApprovalActionStatus(state) {
  return {
    ...state,
    submitCptApprovalActionStatus: ACTION_STATUS.READY,
  };
}

function openDelCptModal(state, data) {
  return {
    ...state,
    delCptModal: {
      ...state.delCptModal,
      isOpened: true,
      respErrMsg: '',
      fields: {
        id: data.id,
      },
    },
  };
}

function startDelCpt(state) {
  return {
    ...state,
    delCptActionStatus: ACTION_STATUS.LOGINING,
  };
}

function delCptSuccess(state) {
  return {
    ...state,
    delCptActionStatus: ACTION_STATUS.SUCCESS,
  };
}

function delCptFailure(state, err) {
  return {
    ...state,
    delCptActionStatus: ACTION_STATUS.ERROR,
    delCptModal: {
      ...state.delCptModal,
      respErrMsg: err && err.respMessage ? err.respMessage : '',
    },
  };
}

function initDelCptActionStatus(state) {
  return {
    ...state,
    delCptActionStatus: ACTION_STATUS.READY,
  };
}

function resetDelCptModal(state) {
  return {
    ...state,
    delCptModal: initialState.delCptModal,
  };
}

function cptNoteChangeInput(state, { name, value }) {
  return {
    ...state,
    cptNoteModal: {
      ...state.cptNoteModal,
      fields: {
        ...state.cptNoteModal.fields,
        [name]: value,
      },
    },
  };
}

function startLoadCptNote(state) {
  return {
    ...state,
    loadCptNoteActionStatus: ACTION_STATUS.LOGINING,
    loadCptNoteRespErrMsg: '',
  };
}

function loadCptNoteSuccess(state, resp) {
  const noteList = resp && Array.isArray(resp.data) ? resp.data : [];
  const noteData = noteList.length > 0 ? noteList[0] : null;
  return {
    ...state,
    loadCptNoteActionStatus: ACTION_STATUS.SUCCESS,
    loadCptNoteRespErrMsg: '',
    cptNoteModal: {
      isOpened: true,
      respErrMsg: '',
      fields: {
        id: noteData ? noteData.id : null,
        note: noteData && noteData.note ? noteData.note : '',
      },
    },
  };
}

function loadCptNoteFailure(state, err) {
  return {
    ...state,
    loadCptNoteActionStatus: ACTION_STATUS.ERROR,
    loadCptNoteRespErrMsg: err && err.respMessage ? err.respMessage : '',
  };
}

function initLoadCptNoteActionStatus(state) {
  return {
    ...state,
    loadCptNoteActionStatus: ACTION_STATUS.READY,
    loadCptNoteRespErrMsg: '',
  };
}

function startAddOrEditCptNote(state) {
  return {
    ...state,
    addOrEditCptNoteActionStatus: ACTION_STATUS.LOGINING,
    cptNoteModal: {
      ...state.cptNoteModal,
      respErrMsg: '',
    },
  };
}

function addOrEditCptNoteSuccess(state) {
  return {
    ...state,
    addOrEditCptNoteActionStatus: ACTION_STATUS.SUCCESS,
  };
}

function addOrEditCptNoteFailure(state, err) {
  return {
    ...state,
    addOrEditCptNoteActionStatus: ACTION_STATUS.ERROR,
    cptNoteModal: {
      ...state.cptNoteModal,
      respErrMsg: err && err.respMessage ? err.respMessage : '',
    },
  };
}

function initAddOrEditCptNoteActionStatus(state) {
  return {
    ...state,
    addOrEditCptNoteActionStatus: ACTION_STATUS.READY,
  };
}

function resetCptNoteModal(state) {
  return {
    ...state,
    cptNoteModal: initialState.cptNoteModal,
  };
}

export default createReducer(initialState, {
  [ON_CPT_QUERY_INPUT_CHANGE]: onCptQueryInputChange,
  [START_LOAD_CPT_EMPLOYEE_OPTIONS]: startLoadCptEmployeeOptions,
  [LOAD_CPT_EMPLOYEE_OPTIONS_SUCCESS]: loadCptEmployeeOptionsSuccess,
  [LOAD_CPT_EMPLOYEE_OPTIONS_FAILURE]: loadCptEmployeeOptionsFailure,
  [INIT_LOAD_CPT_EMPLOYEE_OPTIONS_ACTION_STATUS]: initLoadCptEmployeeOptionsActionStatus,
  [START_LOAD_CPT_INFO]: startLoadCptInfo,
  [LOAD_CPT_INFO_SUCCESS]: loadCptInfoSuccess,
  [LOAD_CPT_INFO_FAILURE]: loadCptInfoFailure,
  [INIT_LOAD_CPT_INFO_ACTION_STATUS]: initLoadCptInfoActionStatus,
  [SELECT_CPT_INFO]: selectCptInfo,
  [OPEN_ADD_OR_EDIT_CPT_MODAL]: openAddOrEditCptModal,
  [ADD_OR_EDIT_CPT_CHANGE_INPUT]: addOrEditCptChangeInput,
  [START_ADD_OR_EDIT_CPT]: startAddOrEditCpt,
  [ADD_OR_EDIT_CPT_SUCCESS]: addOrEditCptSuccess,
  [ADD_OR_EDIT_CPT_FAILURE]: addOrEditCptFailure,
  [INIT_ADD_OR_EDIT_CPT_ACTION_STATUS]: initAddOrEditCptActionStatus,
  [RESET_ADD_OR_EDIT_CPT_MODAL]: resetAddOrEditCptModal,
  [START_SUBMIT_CPT_APPROVAL]: startSubmitCptApproval,
  [SUBMIT_CPT_APPROVAL_SUCCESS]: submitCptApprovalSuccess,
  [SUBMIT_CPT_APPROVAL_FAILURE]: submitCptApprovalFailure,
  [INIT_SUBMIT_CPT_APPROVAL_ACTION_STATUS]: initSubmitCptApprovalActionStatus,
  [OPEN_DEL_CPT_MODAL]: openDelCptModal,
  [START_DEL_CPT]: startDelCpt,
  [DEL_CPT_SUCCESS]: delCptSuccess,
  [DEL_CPT_FAILURE]: delCptFailure,
  [INIT_DEL_CPT_ACTION_STATUS]: initDelCptActionStatus,
  [RESET_DEL_CPT_MODAL]: resetDelCptModal,
  [CPT_NOTE_CHANGE_INPUT]: cptNoteChangeInput,
  [START_LOAD_CPT_NOTE]: startLoadCptNote,
  [LOAD_CPT_NOTE_SUCCESS]: loadCptNoteSuccess,
  [LOAD_CPT_NOTE_FAILURE]: loadCptNoteFailure,
  [INIT_LOAD_CPT_NOTE_ACTION_STATUS]: initLoadCptNoteActionStatus,
  [START_ADD_OR_EDIT_CPT_NOTE]: startAddOrEditCptNote,
  [ADD_OR_EDIT_CPT_NOTE_SUCCESS]: addOrEditCptNoteSuccess,
  [ADD_OR_EDIT_CPT_NOTE_FAILURE]: addOrEditCptNoteFailure,
  [INIT_ADD_OR_EDIT_CPT_NOTE_ACTION_STATUS]: initAddOrEditCptNoteActionStatus,
  [RESET_CPT_NOTE_MODAL]: resetCptNoteModal,
});
